<template>
  <div>
    <div v-if="!numero">
      <body class="font-sans text-gray-700">
        <div class="container mx-auto p-8 flex">
          <div class="max-w-md w-full mx-auto">
            <div class="bg-white rounded-lg shadow-2xl">
              <div class="p-8">
                <!--<a href=".">-->
                <h1 class="text-4xl text-center mb-12 font-thin">
                  Inicia sesión nuevamente
                </h1>

                <a href=".">
                  <button
                    class="
                      w-full
                      p-3
                      font-bold
                      text-xl
                      hover:bg-blue-400
                      mt-1
                      bg-blue-600
                      text-white
                      rounded
                      shadow
                    "
                  >
                    Entrar
                  </button>
                </a>
              </div>

              <div
                class="
                  flex
                  justify-between
                  p-8
                  text-sm
                  border-t border-gray-300
                  bg-gray-100
                "
              ></div>
            </div>
          </div>
        </div>
      </body>
    </div>

    <div>
      <div id="modalCaracteristicas" class="modal">
        <div class="modal-contenido rounded-xl p-1">
          <div class="grid grid-cols-6 justify-items-end">
            <button
              @click="clean()"
              type="button"
              class="col-start-6 end text-xl mx-2 p-1"
            >
              <a class="font-bold" href="#">X</a>
            </button>
          </div>
          <div class="w-full">
            <h4
              class="
                bg-gray-100
                mx-9
                mb-1
                text-2xl
                shadow-xl
                text-black text-center
                mt-1
                rounded
                divide-y divide-red-500
              "
            >
              Caracteristicas
              <hr color="black" size="4" />
            </h4>
          </div>
          <!--<div
          class="border rounded-xl w-80 border-solid border-t-4 border-l-4 border-r-4 border- shadow-2xl"
        >-->
          <div class="">
            <div class="col-span-2 justify-center mt-2">
              <div class="px-10 mx-5">
                <p class="uppercase text-center divide-y text-sm">
                  descripcion
                </p>
                <p
                  class="
                    divide divide-y
                    text-black
                    mx-2
                    border-b-2
                    divide-black
                  "
                  v-if="!banderamodal"
                >
                  <strong v-if="!valor">{{ descripcionmodal }} </strong>
                </p>
                <input
                  v-model="descripcion"
                  v-on:keyup="mostrar()"
                  v-if="valor"
                  class="
                    appearance-none
                    w-full
                    mx-2
                    w-80
                    border-b-2 border-black
                    shadow-xl
                    block
                    col-span-3
                    bg-gray-lighter
                    text-grey-darker
                    rounded
                    py-1
                  "
                  type="text"
                />
                <input
                  v-model="descripcion"
                  v-on:keyup="mostrar()"
                  v-if="banderamodal"
                  class="
                    appearance-none
                    w-full
                    mx-2
                    w-80
                    border-b-2 border-black
                    shadow-xl
                    block
                    col-span-3
                    bg-gray-lighter
                    text-grey-darker
                    rounded
                    py-1
                  "
                  type="text"
                />
              </div>
            </div>

            <div class="inline flex justify-center">
              <div>
                <button
                  v-if="!banderamodal"
                  @click="mostrarinicial()"
                  type="button"
                  class="
                    w-full
                    inline-flex
                    justify-center
                    mt-5
                    rounded-md
                    border border-transparent
                    shadow-sm
                    px-2
                    py-1
                    bg-green-400
                    text-base
                    font-medium
                    text-white
                    hover:bg-green-300
                    focus:outline-none
                    focus:ring-2 focus:ring-offset-2 focus:ring-green-500
                    sm:ml-3
                    sm:w-auto
                    sm:text-sm
                  "
                >
                  Modificar
                </button>
              </div>
              <div class="col-span-1 mx-2">
                <button
                  @click="agregartable(), clean(), recargar()"
                  type="button"
                  class="
                    w-full
                    inline-flex
                    justify-center
                    mt-5
                    rounded-md
                    border border-transparent
                    shadow-sm
                    px-2
                    py-1
                    bg-blue-600
                    text-base
                    font-medium
                    text-white
                    hover:bg-blue-400
                    focus:outline-none
                    focus:ring-2 focus:ring-offset-2 focus:ring-blue-500
                    sm:ml-3
                    sm:w-auto
                    sm:text-sm
                  "
                >
                  <a href="#"> Guardar </a>
                </button>
                <button class="bg-blue400"></button>
              </div>
            </div>
          </div>
          <!--</div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
//import axios from "axios";
export default {
  name: "modalCaracteristicas",
  data() {
    return {
      caracteristica: "",
      respuesta: null,
      idlinea: "",
      nombrelinea: "",
      value: null,
      descripcion: "",
      valor: false,
    };
  },

  methods: {
    ...mapMutations("caracteristicas", [
      "agregartable",
      "cambio",
      "cargardatoscaracteristicas",
    ]),

    mostrar() {
      this.cambio(this.descripcion);
    },
    mostrarinicial() {
      this.descripcion = this.descripcionmodal;
      this.valor = true;
    },

    clean() {
      this.descripcion = null;
      this.valor = false;
    },
    async recargar() {
      setTimeout(() => {
        this.cargardatoscaracteristicas();
      }, 500);
    },
  },
  computed: {
    ...mapState("caracteristicas", [
      "idmodal",
      "descripcionmodal",
      "caracteristicas",
    ]),
    ...mapState([
      "elemento",
      "id",
      //"descripcion",
      "numero",
      // "idmodal",
      //"descripcionmodal",
      "banderamodal",
    ]),
  },
};
</script>
<style scoped >
.modal-contenido {
  background-color: rgb(255, 255, 255);
  width: 500px;
  height: auto;

  margin: auto;
  margin-top: 100px;
  position: relative;
}
.modal {
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0;
  pointer-events: none;
  transition: all 0.1s;
}
#modalCaracteristicas:target {
  opacity: 1;
  pointer-events: auto;
}
</style>

